<script>
  import { push } from "svelte-spa-router"
  import ApplicationState from "../../../Stores/applicationStates"
  import notify from "../../../Script/notify"
  import { copyToClipboard } from "../../../Pages/Publish/SinglePublish/script"
  import FeatureState from "../../../Stores/featureState"

  export let state = {}
  export let showUserInfo
  /**
   * @type {copiedInfo}
   */
  let copiedInfo = {
    close() {},
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="fixed inset-0 z-50 h-screen w-screen select-none overflow-auto bg-[#f7f7f7]/50 backdrop-blur-md dark:bg-bodyblack/50">
  <div
    on:click|self={() => {
      showUserInfo = false
    }}
    class="flex flex-col items-center justify-center gap-6 p-6"
  >
    <div class="w-full rounded-xl border-t-8 border-[#ff6a00] bg-white shadow-md dark:bg-mdGray md:w-[75%] xl:w-[55%]">
      <div class="flex w-fit justify-start rounded-b-xl rounded-tl-sm bg-[#ff6a00] px-6 py-2">
        <h2 class="select-none truncate text-sm font-bold text-gray-700 dark:text-white">V {$FeatureState.version || "2.0.0"}</h2>
      </div>
      <div class="flex h-full items-start gap-6 p-6">
        <div class="hidden h-24 w-24 flex-shrink-0 items-center justify-center rounded-full bg-[#EBF6FA] dark:bg-bodyblack mobile:flex">
          <img class="inline-block h-16 w-16 rounded-full" src="assets/img/user.png" alt="" />
        </div>

        <div class="flex h-full w-full flex-col justify-between">
          <div class="flex w-full items-start justify-between">
            <div class="mt-3 flex w-full items-center gap-6">
              <div class="flex flex-col gap-2">
                <h1 class=" text-xl font-extrabold tracking-wide text-black dark:text-white">{state.name}</h1>
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <div
                  on:click={async () => {
                    copiedInfo.close()
                    await copyToClipboard(state.issuerID)
                    copiedInfo = notify.info("Issuer ID copied to clipboard")
                  }}
                  class="cursor-pointer truncate break-words text-base font-semibold tracking-widest text-slate-500 hover:text-slate-600 mobile:text-xl"
                >
                  {state.issuerID}
                </div>
                <div class="flex cursor-pointer items-center gap-2">
                  <!-- svelte-ignore a11y-click-events-have-key-events -->
                  <div
                    on:click={async () => {
                      copiedInfo.close()
                      await copyToClipboard(state.email)
                      copiedInfo = notify.info("Email ID copied to clipboard")
                    }}
                    class="text-lg font-semibold tracking-wide text-blue-400 hover:text-blue-500"
                  >
                    {state.email}
                  </div>
                  <span>
                    <i class="fa-solid fa-circle-check text-green-500" />
                  </span>
                </div>
              </div>
            </div>

            <button
              on:click={() => {
                showUserInfo = false
              }}
              class="mx-auto flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border-0 p-1 text-base font-semibold text-red-500 hover:bg-red-500 hover:text-white focus:outline-none"
            >
              <i class="fa-solid fa-xmark" />
            </button>
          </div>

          <div class="mt-12 grid w-full grid-cols-2 items-center justify-between gap-3 lg:grid-cols-4">
            <button
              on:click={() => {
                $ApplicationState.darkMode = !$ApplicationState.darkMode
              }}
              class="flex w-full flex-col items-center justify-center rounded-xl bg-[#F4F8FB] py-5 text-[#8092A6] shadow-md hover:bg-sky-100 dark:bg-[#2d2d30] dark:hover:bg-orange-500 dark:hover:text-white"
            >
              <span>
                <i class="fa-solid {$ApplicationState.darkMode ? 'fa-brightness' : 'fa-moon'}  text-2xl" />
              </span>
              <h1 class="mt-2 text-base font-semibold tracking-wide">{$ApplicationState.darkMode ? "Light" : " Dark"}</h1>
            </button>

            <button class="flex w-full cursor-not-allowed flex-col items-center justify-center rounded-xl bg-[#F4F8FB] py-5 text-[#8092A6] shadow-md hover:bg-sky-100 dark:bg-[#2d2d30] dark:hover:bg-orange-500 dark:hover:text-white">
              <span>
                <i class="fa-solid fa-pen-to-square text-2xl" />
              </span>
              <h1 class="mt-2 text-base font-semibold tracking-wide">Edit Email</h1>
            </button>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <button
              on:click={() => {
                push("/settings/integration/home")
                showUserInfo = false
              }}
              class="flex w-full flex-col items-center justify-center rounded-xl bg-[#F4F8FB] py-5 text-[#8092A6] shadow-md outline-none hover:bg-sky-100 dark:bg-[#2d2d30] dark:hover:bg-orange-500 dark:hover:text-white"
            >
              <span>
                <i class="fa-solid fa-gear text-2xl" />
              </span>
              <h1 class="mt-2 text-base font-semibold tracking-wide">Settings</h1>
            </button>

            <button
              on:click={() => {
                $ApplicationState = {}
                localStorage.clear()
                push("/")
                notify.success("Logged out successfully!")
              }}
              class="flex w-full flex-col items-center justify-center rounded-xl bg-[#F4F8FB] py-5 text-[#8092A6] shadow-md hover:bg-sky-100 dark:bg-[#2d2d30] dark:hover:bg-orange-500 dark:hover:text-white"
            >
              <span>
                <i class="fa-solid fa-right-from-bracket text-2xl" />
              </span>
              <h1 class="mt-2 text-base font-semibold tracking-wide">Logout</h1>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full rounded-xl border-t-8 border-[#ff6a00] bg-white shadow-md dark:bg-mdGray md:w-[75%] xl:w-[55%]">
      <div class="flex h-full items-start gap-6 p-6">
        <div class="hidden h-32 w-32 flex-shrink-0 items-center justify-center rounded bg-[#EBF6FA] dark:bg-bodyblack mobile:flex">
          <img class="inline-block h-24 w-24 rounded" src="assets/img/windows.png" alt="" />
        </div>
        <div class="flex h-full w-full flex-col justify-between">
          <div class="flex flex-col gap-1">
            <h1 class="text-lg font-semibold tracking-wider text-[#ff6a00]">Navigator client info</h1>
            <div class="flex flex-col gap-0.5">
              <span class="text-sm font-semibold text-gray-500">Browser:</span>
              <h1 class="pb-2 text-sm font-extrabold tracking-wide text-black/70 dark:text-white/70">{window.navigator.userAgent}</h1>
            </div>
            <div class="flex flex-col gap-0.5">
              <span class="text-sm font-semibold text-gray-500">Screen Resolution:</span>
              <h1 class="pb-2 text-base font-extrabold tracking-wide text-black/70 dark:text-white/70">{window.innerWidth}px X {window.innerHeight}px</h1>
            </div>
            <div class="flex flex-col gap-0.5">
              <span class="text-sm font-semibold text-gray-500">Operating System:</span>

              <div class="flex w-full justify-between">
                <h1 class="pb-2 text-sm font-extrabold tracking-wide text-black/70 dark:text-white/70">{window.navigator.platform}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
